import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import {
	Badge,
	Box,
	Button,
	FormControl,
	FormLabel,
	Grid,
	GridItem,
	HStack,
	Icon,
	Input,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	Select,
	Stack,
	Table,
	Tbody,
	Td,
	Text,
	Th,
	Thead,
	Tr,
	useColorModeValue,
	useDisclosure,
	useToast,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import moment from "moment";
import { FiEdit2, FiEye, FiSave, FiX } from "react-icons/fi";

import Dropzone from "../../Components/Dropzone/Dropzone";
import Gallery from "../../Components/Gallery/Gallery";
import OwnerDocumentsTableRow from "../../Components/TableRows/OwnerDocumentsTableRow";
import { addOwnerDocumentAsync, updateOwnerAsync, uploadOwnerIdAsync } from "../../redux/user/userSlice";
import { _arrayBufferToBase64 } from "../../utils/convertors";
import { API } from "../../utils/http";
import { fullDateFormat } from "../../utils/types";

const MotionBox = motion(Box);

export default function PersonalInformation({ owner }) {
	const initialIdInformation = { idData: "", contentType: "", ownerEmail: owner.email, expirationDate: "", dateOfBirth: "" };
	const initialOwnerInformation = {
		name: owner.name,
		phoneNumber: owner.phoneNumber,
		phoneNumber2: owner.phoneNumber2,
		ownerEmail: owner.email,
		expirationDate: owner.identificationDocument?.expirationDate,
		dateOfBirth: owner.identificationDocument?.dateOfBirth,
		bankAccount: owner.bankDetails.account,
		administrationFeePercent: owner.bankDetails.administrationFeePercent,
		bankAccountCurrency: owner.bankDetails.currency,
	};
	const { isOpen, onOpen, onClose } = useDisclosure();
	const { isOpen: isAddDocumentOpen, onOpen: onAddDocumentOpen, onClose: onAddDocumentClose } = useDisclosure();
	const { isOpen: isPreviewOpen, onOpen: onPreviewOpen, onClose: onPreviewClose } = useDisclosure();
	const [isEditing, setIsEditing] = useState(false);
	const [idInformation, setIdInformation] = useState(initialIdInformation);
	const [documentInformation, setDocumentInformation] = useState();
	const [id, setId] = useState([]);
	const [ownerInformation, setOwnerInformation] = useState(initialOwnerInformation);
	const dispatch = useDispatch();
	const toast = useToast();

	const bgColor = useColorModeValue("white", "gray.800");
	const borderColor = useColorModeValue("gray.200", "gray.700");
	const labelColor = useColorModeValue("gray.600", "gray.400");
	const valueColor = useColorModeValue("gray.800", "white");

	const uploadId = () => {
		console.log(idInformation);
		dispatch(uploadOwnerIdAsync(idInformation))
			.then((r) => {
				if (r.error?.message)
					toast({
						title: "Error encountered",
						description: r.error.message,
						status: "error",
						duration: 9000,
						isClosable: true,
					});
				else {
					toast({
						title: "Success!",
						description: "ID Added!",
						status: "success",
						duration: 2000,
						isClosable: true,
					});
				}
			})
			.finally(() => {
				setIdInformation(initialIdInformation);
				onClose();
			});
	};
	const addDocument = () => {
		console.log(documentInformation);
		const payload = { ...documentInformation, email: owner.email };
		console.log(payload);
		dispatch(addOwnerDocumentAsync(payload))
			.then((r) => {
				if (r.error?.message)
					toast({
						title: "Error encountered",
						description: r.error.message,
						status: "error",
						duration: 9000,
						isClosable: true,
					});
				else {
					toast({
						title: "Success!",
						description: "Document Added!",
						status: "success",
						duration: 2000,
						isClosable: true,
					});
				}
			})
			.finally(() => {
				setDocumentInformation();
				onAddDocumentClose();
			});
	};
	const onDocumentDrop = async (acceptedFiles) => {
		console.log(acceptedFiles);
		const buffer = await acceptedFiles[0].arrayBuffer();
		const contentType = acceptedFiles[0].type;
		const documentName = acceptedFiles[0].name;
		// setIdInformation({ ...idInformation, idData: _arrayBufferToBase64(buffer), contentType });
		setDocumentInformation({ ...documentInformation, documentData: _arrayBufferToBase64(buffer), documentName, contentType });
	};
	useEffect(() => {
		console.log("getting owner id");
		if (owner.identificationDocument.id)
			API.put("get-owner-document-url", { ownerEmail: owner.email, documentId: owner.identificationDocument.id }).then((r) => {
				console.log(r.data);
				console.log(r.data.id);
				setId([{ ...owner.identificationDocument, url: r.data.url }]);
			});
	}, [owner]);
	const onIdDrop = async (acceptedFiles) => {
		console.log(acceptedFiles);
		const buffer = await acceptedFiles[0].arrayBuffer();
		const contentType = acceptedFiles[0].type;
		setIdInformation({ ...idInformation, idData: _arrayBufferToBase64(buffer), contentType });
	};
	const handleSave = () => {
		console.log(ownerInformation);
		dispatch(updateOwnerAsync(ownerInformation));
	};
	const handleIdInformationChange = (e) => {
		setIdInformation({ ...idInformation, [e.target.name]: e.target.value });
	};
	const handleOwnerInformationChange = (e) => {
		setOwnerInformation({ ...ownerInformation, [e.target.name]: e.target.value });
	};
	const renderAddDocumentModal = () => (
		<Modal isOpen={isAddDocumentOpen} onClose={onAddDocumentClose} size={"xl"}>
			<ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
			<ModalContent>
				<ModalHeader>
					<Text>Add Document</Text>
				</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<Stack>
						<FormControl display={"flex"} alignItems="center">
							<FormLabel display={"inline"}>Type:</FormLabel>
							<Select
								width={"fit-content"}
								onChange={(e) => {
									setDocumentInformation({ ...documentInformation, type: e.target.value });
								}}
								name="type"
								placeholder="Type"
								_placeholder={{ color: "gray.500" }}
							>
								<option value="certificate">Adeverinta</option>
								<option value="passport">Pasaport</option>
								<option value="passport">Extras de Cont</option>
								<option value="other">Altele</option>
							</Select>
						</FormControl>
						<Dropzone onDrop={onDocumentDrop} accept={{ "application/*": [".pdf"], "image/*": [] }} description="Upload a Document" maxFiles={1} />
					</Stack>
				</ModalBody>
				<ModalFooter>
					<Button colorScheme="red" onClick={onAddDocumentClose} mr={3}>
						Cancel
					</Button>
					<Button colorScheme="blue" onClick={addDocument}>
						Upload
					</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
	const renderUploadIdModal = () => (
		<Modal isOpen={isOpen} onClose={onClose} size={"xl"}>
			<ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
			<ModalContent>
				<ModalHeader>
					<Text>Add ID</Text>
				</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<Text fontWeight={"bold"} marginBottom="20px">
						Add ID
					</Text>
					<Stack>
						<FormControl>
							<FormLabel display={"inline"}>Expiration Date:</FormLabel>
							<Input width={"fit-content"} type="date" value={idInformation.expirationDate} name="expirationDate" onChange={handleIdInformationChange} />
						</FormControl>
						<FormControl>
							<FormLabel display={"inline"}>Date of Birth:</FormLabel>
							<Input width={"fit-content"} type="date" value={idInformation.dateOfBirth} name="dateOfBirth" onChange={handleIdInformationChange} />
						</FormControl>
						<FormControl>
							<FormLabel>ID:</FormLabel>
							<Dropzone
								onDrop={onIdDrop}
								accept={{ "application/*": [".pdf"], "image/*": [".jpeg", ".jpg", ".png"] }}
								description="Upload an Image"
								maxFiles={1}
							/>
						</FormControl>
					</Stack>
				</ModalBody>
				<ModalFooter>
					<Button colorScheme="red" onClick={onClose} mr={3}>
						Cancel
					</Button>
					<Button colorScheme="blue" onClick={uploadId}>
						Upload
					</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
	const renderIdPreviewModal = () => (
		<Modal isOpen={isPreviewOpen} onClose={onPreviewClose} size="4xl">
			<ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
			<ModalContent>
				<ModalHeader>ID Document</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<Box borderRadius="md" overflow="hidden">
						<Gallery items={id} />
					</Box>
				</ModalBody>
			</ModalContent>
		</Modal>
	);
	return (
		<MotionBox initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
			<Grid templateColumns={{ base: "1fr", md: "repeat(3, 1fr)" }} gap={8}>
				<GridItem>
					<Box p={6} bg={bgColor} borderRadius="lg" borderWidth="1px" borderColor={borderColor} boxShadow="sm" position="relative">
						<HStack justify="space-between" mb={6}>
							<Text fontSize="lg" fontWeight="bold">
								Personal Details
							</Text>
							<Button
								size="sm"
								variant="ghost"
								colorScheme={isEditing ? "red" : "blue"}
								leftIcon={<Icon as={isEditing ? FiX : FiEdit2} />}
								onClick={() => {
									if (isEditing) {
										setOwnerInformation(initialOwnerInformation);
									}
									setIsEditing(!isEditing);
								}}
							>
								{isEditing ? "Cancel" : "Edit"}
							</Button>
						</HStack>

						<Stack spacing={4}>
							<FormControl>
								<FormLabel color={labelColor}>Name</FormLabel>
								{isEditing ? (
									<Input size="md" value={ownerInformation.name} name="name" onChange={handleOwnerInformationChange} />
								) : (
									<Text color={valueColor}>{ownerInformation.name}</Text>
								)}
							</FormControl>

							<FormControl>
								<FormLabel color={labelColor}>Primary Phone</FormLabel>
								{isEditing ? (
									<Input size="md" value={ownerInformation.phoneNumber} name="phoneNumber" onChange={handleOwnerInformationChange} />
								) : (
									<Text color={valueColor}>{ownerInformation.phoneNumber}</Text>
								)}
							</FormControl>

							<FormControl>
								<FormLabel color={labelColor}>Secondary Phone</FormLabel>
								{isEditing ? (
									<Input size="md" value={ownerInformation.phoneNumber2} name="phoneNumber2" onChange={handleOwnerInformationChange} />
								) : (
									<Text color={valueColor}>{ownerInformation.phoneNumber2 || "-"}</Text>
								)}
							</FormControl>

							<FormControl>
								<FormLabel color={labelColor}>Email</FormLabel>
								<Text color={valueColor}>{ownerInformation.ownerEmail}</Text>
							</FormControl>

							{isEditing && (
								<Button colorScheme="blue" leftIcon={<Icon as={FiSave} />} onClick={handleSave} mt={4}>
									Save Changes
								</Button>
							)}
						</Stack>
					</Box>
				</GridItem>

				<GridItem>
					<Box p={6} bg={bgColor} borderRadius="lg" borderWidth="1px" borderColor={borderColor} boxShadow="sm">
						<Text fontSize="lg" fontWeight="bold" mb={6}>
							Identification
						</Text>
						<Stack spacing={4}>
							<FormControl>
								<FormLabel color={labelColor}>ID Expiration Date</FormLabel>
								<HStack>
									{owner.identificationDocument?.expirationDate ? (
										<Badge colorScheme={moment(owner.identificationDocument.expirationDate).unix() < moment().unix() ? "red" : "green"}>
											{moment(owner.identificationDocument.expirationDate).format(fullDateFormat)}
										</Badge>
									) : (
										<Text color={valueColor}>No ID uploaded</Text>
									)}
									<Button size="sm" colorScheme="blue" onClick={onOpen}>
										{owner.identificationDocument?.id ? "Update ID" : "Upload ID"}
									</Button>
								</HStack>
							</FormControl>

							<FormControl>
								<FormLabel color={labelColor}>Date of Birth</FormLabel>
								<Text color={valueColor}>
									{owner.identificationDocument ? moment(owner.identificationDocument?.dateOfBirth).format(fullDateFormat) : "No ID uploaded"}
								</Text>
							</FormControl>

							{owner.identificationDocument?.id && (
								<FormControl>
									<FormLabel color={labelColor}>ID Preview</FormLabel>
									<Button leftIcon={<Icon as={FiEye} />} size="sm" variant="outline" colorScheme="blue" onClick={onPreviewOpen}>
										View ID Document
									</Button>
								</FormControl>
							)}
						</Stack>
					</Box>
				</GridItem>

				<GridItem>
					<Box p={6} bg={bgColor} borderRadius="lg" borderWidth="1px" borderColor={borderColor} boxShadow="sm">
						<Text fontSize="lg" fontWeight="bold" mb={6}>
							Bank Details
						</Text>
						<Stack spacing={4}>
							<FormControl>
								<FormLabel color={labelColor}>Bank Account</FormLabel>
								{isEditing ? (
									<Input size="md" value={ownerInformation.bankAccount} name="bankAccount" onChange={handleOwnerInformationChange} />
								) : (
									<Text color={valueColor}>{ownerInformation.bankAccount}</Text>
								)}
							</FormControl>

							<FormControl>
								<FormLabel color={labelColor}>Administration Fee (%)</FormLabel>
								{isEditing ? (
									<Input
										size="md"
										value={ownerInformation.administrationFeePercent}
										name="administrationFeePercent"
										onChange={handleOwnerInformationChange}
										type="number"
									/>
								) : (
									<Text color={valueColor}>{ownerInformation.administrationFeePercent}%</Text>
								)}
							</FormControl>

							<FormControl>
								<FormLabel color={labelColor}>Currency</FormLabel>
								{isEditing ? (
									<Select size="md" value={ownerInformation.bankAccountCurrency} name="bankAccountCurrency" onChange={handleOwnerInformationChange}>
										{/* TODO: eur and ron lowercase */}
										<option value="ron">RON</option>
										<option value="eur">EUR</option>
									</Select>
								) : (
									<Text color={valueColor}>{ownerInformation.bankAccountCurrency}</Text>
								)}
							</FormControl>
						</Stack>
					</Box>
				</GridItem>

				<GridItem colSpan={{ base: 1, md: 3 }}>
					<Box p={6} bg={bgColor} borderRadius="lg" borderWidth="1px" borderColor={borderColor} boxShadow="sm">
						<HStack justify="space-between" mb={6}>
							<Text fontSize="lg" fontWeight="bold">
								Documents
							</Text>
							<Button size="sm" colorScheme="blue" onClick={onAddDocumentOpen}>
								Add Document
							</Button>
						</HStack>

						<Table variant="simple">
							<Thead>
								<Tr>
									<Th>Type</Th>
									<Th>Name</Th>
									<Th>Upload Date</Th>
									<Th>Actions</Th>
								</Tr>
							</Thead>
							<Tbody>
								{owner.documents?.length > 0 ? (
									owner.documents.map((doc) => {
										console.log("doc: ", doc);
										return <OwnerDocumentsTableRow key={doc.id} document={doc} ownerEmail={owner.email} />;
									})
								) : (
									<Tr>
										<Td colSpan={4}>
											<Box py={4} textAlign="center">
												<Text color={labelColor}>No documents uploaded yet</Text>
												<Button size="sm" colorScheme="blue" variant="link" onClick={onAddDocumentOpen} mt={2}>
													Upload your first document
												</Button>
											</Box>
										</Td>
									</Tr>
								)}
							</Tbody>
						</Table>
					</Box>
				</GridItem>
			</Grid>

			{renderAddDocumentModal()}
			{renderUploadIdModal()}
			{renderIdPreviewModal()}
		</MotionBox>
	);
}
